module.exports = __webpack_public_path__ + "static/media/saveprofile.1f2da432.png";